import logo from "../../assets/images/logo.svg";

export const PageLoader = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen ">
      <div className="relative inline-flex">
        <div>
          <img className="w-20 h-20 rounded-full" src={logo}></img>{" "}
        </div>
        <div className="w-20 h-20 bg-loader-background rounded-full absolute top-0 left-0 animate-ping"></div>
        <div className="w-20 h-20 bg-loader-background rounded-full absolute top-0 left-0 animate-pulse"></div>
      </div>
      <div className="mt-8">
        <span className="text-xl text-grey-scale-slate ">Loading ...</span>
      </div>
    </div>
  );
};
